module.exports = __webpack_public_path__ + "img/card-list.b31489af.svg";